
export function syncJSON(requestMethod: string, requestUrl: string, data: any, callback: (msg: any) => void): void {

    $.ajax({
        type: requestMethod,
        async: false,
        url: requestUrl,
        contentType: "application/json",
        dataType: "json",
        data: data,
        success: function (msg) { callback(msg) },
        error: function (msg) { console.log('error : ' + msg); }          // msg.d
        //error: function (msg) { alert('error : ' + msg.d); }
    });
}

